import { Component, inject, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectPastEventBookings, selectUpcomingEventBookings } from '../../../data-services/stores/selectors/user.selectors';
import { AsyncPipe, DatePipe } from '@angular/common';
import { UserActions } from '../../../data-services/stores/actions/user.actions';
import { TicketTypes } from '../../../data-services/models/event-bookings/event-booking-detailed.model';
import { RouterModule } from '@angular/router';
import { PaypalComponent } from '../../../core/paypal/feature/paypal.component';
import { BoilerplateComponent } from '../../../core/boilerplate/feature/boilerplate.component';
import { Title } from '@angular/platform-browser';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { EventBookingTileComponent } from '../../../core/event-booking-tile/feature/event-booking-tile.component';

@Component({
  selector: 'app-event-bookings',
  imports: [AsyncPipe,DatePipe,RouterModule,BoilerplateComponent,FontAwesomeModule,EventBookingTileComponent],
  templateUrl: '../ui/event-bookings.component.html',
  styleUrl: '../ui/event-bookings.component.css'
})
export class EventBookingsComponent  implements OnInit{
  private readonly _store = inject(Store);
  private readonly _titleService = inject(Title);
  upcomingEventBookings$ = this._store.select(selectUpcomingEventBookings);
  pastEventBookings$ = this._store.select(selectPastEventBookings);

  ngOnInit(): void {
    this._titleService.setTitle('LRPTickets.co.uk | My Event Bookings')
    this._store.dispatch(UserActions.loadUser({ refresh: false}));
  }

  public get TicketTypes(): typeof TicketTypes {
    return TicketTypes; 
  }

}
